




























































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
import {message, UserWithMessage} from '@/store/Friends/types';
import * as _ from 'lodash';

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');

@Component({
  components: {
    BButton,
  },
})

export default class GiftCoins extends Vue {
  @Prop() public readonly selectedCoinPayment: any;
  @userNamespace.State('self') public readonly myself!: MAFUser;
  @friendNamespace.Action('giftCoinsToFriend') public giftCoinsToFriend!: any;
  @friendNamespace.Action('sendEmailNotification') public sendEmailNotification!: any;
  @friendNamespace.Getter('getFriendsAndMessages') public getFriendMessages!: UserWithMessage[];

  public selectedFriend: MAFUser = new MAFUser(undefined);
  public isFriendSelected: boolean = false;
  public isGifting: boolean = false;
  public coinsGift: number = 0;
  public BASE_URL: string;

  constructor() {
    super();
    this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
  }

  get filteredFriends() {
    // return if they're not blocking me && I'm not blocking them && they exist
    const ffriends = this.getFriendMessages.filter((f) => f.user.uid &&
      !this.myself.blockingMe.includes(f.user.uid) &&
      !this.myself.blocked.includes(f.user.uid));

    // sort alphabetically
    const sort = _.sortBy(ffriends, 'user.name');
    return sort;
  }

  get canShareCoins() {
    return this.coinsGift < this.myself.coins && this.coinsGift !== 0 && !this.isGifting;
  }
  /* tslint:disable:max-line-length */
  public async giftCoins() {
    this.isGifting = true;
    try {
      await this.giftCoinsToFriend({me: this.myself, friend: this.selectedFriend, gift: this.coinsGift});

      this.sendEmailNotification({to: this.selectedFriend.email, mess: `Hello, ${this.selectedFriend.name}! ${this.myself.name} has gifted you ${this.coinsGift} coins to use for unlocking audio/video chat or premium avatar items! That was really nice of them.`});
      this.sendEmailNotification({to: this.myself.email, mess: `Hello, ${this.myself.name}! You have gifted ${this.selectedFriend.name} ${this.coinsGift} coins. This email is for your records.`});
    } catch (error) {
      console.error(error);
    }

    this.close();
    this.isGifting = false;
  }

  @Watch('selectedFriend')
  public onFriendSelect( option: string ) {
    this.isFriendSelected = (option && option.length !== 0) ? true : false;
  }

  @Emit('close')
  public close() {
  }
}
